// extracted by mini-css-extract-plugin
export var productImage = "_ok-1";
export var viewLink = "_ok-2";
export var wishlistItem = "_ok-0";